// extracted by mini-css-extract-plugin
export var option = "_2t-0";
export var optionSelected = "_2t-1 _2t-0";
export var optionUnselected = "_2t-2 _2t-0";
export var radioInner = "_2t-5";
export var radioOuter = "_2t-3";
export var radioOuterSelected = "_2t-4 _2t-3";